<template>
  <div
    :class="['scene', `scene--${type}`, `scene--${flag}`]"
  >
    <!-- home section [start] -->
      <div v-if="currentSceneTest && currentSceneTest.type === 'home'">
        <div class="scene__icon" @click="fullScreen" key="button">
          <div class="scene__img">
            <slot name="image" />
          </div>
          <div :class="`scene__flag scene__flag--${flag} flag`" v-html="sceneData.title[lang]" />
        </div>
      </div>
    <!-- home section [end] -->

    <!-- 1-st level tile [start] -->
      <div class="scene__full" v-if="currentSceneTest && currentSceneTest.type === 'scene'">
        <div class="scene__full-img">
          <div class="image-full">
            <slot name="imageFull" />
          </div>
          <MarkItem
            v-for="mark in sceneData.marks"
            class="mark"
            :key="mark._id"
            :mark="mark"
          />
        </div>
      </div>
    <!-- 1-st level tile [end] -->

    <!-- 2-nd level tile [end] -->
      <div :class="`subscene scene__full ${isLarge ? 'is-large' : '' }`" v-if="currentSceneTest && currentSceneTest.type === 'subscene'" ref="sceneFull">
        <div class="subscene scene__full-img" ref="sceneFullImg">
          <img :src="sceneData.imageSmall" ref="sceneImage" />
          <MarkItem
            v-for="mark in sceneData.marks"
            class="mark"
            :key="mark._id"
            :mark="mark"
          />
        </div>
      </div>
    <!-- 2-nd level tile [end] -->
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import MarkItem from "@/components/Infographics/MarkItem";
import scenes from "@/data";

export default {
  name: "scene-full",
  data() {
    return {
      isLarge: false
    };
  },
  props: {
    subSceneType: String,
    type: String,
    flag: String,
    scene: Object,
    index: Number,
  },
  computed: {
    ...mapState(["lang", "currentScene", "subScene", "infographics", "infographicsScenes"]),
    currentSceneTest() {
      return this.$route.params.scene
        ? this.infographicsScenes.find(s => s._id === this.$route.params.scene)
        : this.infographicsScenes.find(s => s.type === 'home');
    },
    sceneData() {
      return this.scene;
    }
  },
  methods: {
    ...mapMutations(["setScene"]),
    fullScreen() {
      this.$router.push({
        name: "Infographics Scene",
        params: {
          id: this.infographics._id,
          scene: this.sceneData._id,
        }
      });
    }
  },
  mounted: function() {
    this.$nextTick(() => {
      if (this.$refs.sceneImage) {
        this.$refs.sceneImage.onload = () => {

          if (this.$refs.sceneFull && this.$refs.sceneFullImg) {
            const sceneFullBottom = this.$refs.sceneFull.getBoundingClientRect().bottom;
            const sceneFullImgBottom = this.$refs.sceneFullImg.getBoundingClientRect().bottom;

            if ((sceneFullBottom + 20) < sceneFullImgBottom) {
              this.isLarge = true;
            }
          }
        }
      }
    })
  },

  components: {
    MarkItem
  }
};
</script>

<style lang="scss" scoped>
.image-full {
  // max-width: 768px;
}

.scene {
  display: inline-block;

  &--left {
    padding-left: 150px;
  }

  &--right {
    padding-right: 150px;
  }

  &__subscene {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  &__icon {
    position: relative;
    animation: fly 4s ease-in-out infinite alternate;
    will-change: transform;
    transition: transform 0.3s;
    cursor: pointer;

    .scene__img {
      will-change: transform;
      transition: transform 0.3s;
    }

    &:hover {
      animation-play-state: paused;

      .scene__img {
        transform: scale(1.05);
      }
    }

    .scene--souverenty & {
      animation-delay: 0s;
    }
    .scene--interoperability & {
      animation-delay: 2s;
    }
    .scene--sustainability & {
      animation-delay: 4s;
    }
  }

  &__flag {
    position: absolute;
    bottom: 205px;
    min-height: 65px;
    min-width: 225px;
    text-align: left;
    background: #ebf4f9;
    font-size: 27px;
    color: #004169;
    font-weight: 700;
    padding: 15px 0;
    z-index: -1;

    &--right {
      left: calc(100% - 100px);
      background: url("~@/assets/flag-right.svg") no-repeat right;
      background-size: cover;
      padding-left: 100px;
      padding-right: 35px;
    }

    &--left {
      right: calc(100% - 100px);
      background: url("~@/assets/flag-left.svg") no-repeat left;
      background-size: cover;
      padding-right: 100px;
      padding-left: 35px;
    }
  }

  &__full {
    position: absolute;
    top: 0;
    left: 0;
    width: 1920px;
    height: 100%;
    display: flex;
    justify-content: center;
    transform: scale(0.85);
    align-items: flex-end;

    &.subscene {
      align-items: center;
      padding-left: 300px;

      &.is-large {
        align-items: flex-end;
      }
    }
  }

  &__full-img {
    position: relative;
    margin-left: 300px;

    &.subscene img {
      max-width: 1280px;
      width: 100%;
      min-width: 1080px;
    }
  }
}

.zoom-enter-active {
  transition: all 0.3s ease;
}
.zoom-enter {
  transform: scale(0);
  opacity: 0;
}

@keyframes fly {
  0% {
    transform: translateY(0);
  }

  100% {
    transform: translateY(-15px);
  }
}
</style>

